<template>
  <div
    class="secondary-header"
  >
    <div
      :class="computedSecondaryHeaderClass"
    >
      <div class="secondary-header--left" >
        <div v-if="!compressed">

          <span v-if="breadcrumbs.length > 0" class="secondary-header--breadcrumbs">
            <span 
              class="back-icon"
              v-for="(crumb, idx) in breadcrumbs"
            >
              <router-link :to="crumb.link">
                <span> {{ $t(crumb.label) }} </span>
              </router-link>
            </span>
          </span>

          <!-- Deprecated breadcrumbs -- instead use explicit breadcrumbs above -->
          <div class="secondary-header--subtitle"
            v-if="level == 3 && !projectLeadEdit()"
            v-on:click="onClick"
          >
            <span class="back-icon">
              <router-link :to="subtitle.link">
                <span> {{ $t("ui.breadcrump.back") }} </span>
              </router-link>
            </span>
          </div>

          <!-- Special breadcrumb code for the leads list and edit pages -->
          <!-- These two special cases should be replaced with standard breadcrumbs -->
          <div v-if="projectLeadEdit()">
            <div class="secondary-header--subtitle">
              <span class="back-icon">
                <router-link :to="{name: 'projects' }">
                  <span> {{ $t("ui.breadcrump.all_projects") }} </span>
                </router-link>
              </span>

              <span class="back-icon">
                <router-link :to="getProjectPathWithQueries()">
                  <span> {{ getProjectName() }} </span>
                </router-link>
              </span>
            </div>
          </div>

          <div class="secondary-header--subtitle"
            v-else-if="projectLeads()"
            v-on:click="onClick"
          >
            <span class="back-icon">
              <router-link :to="subtitle.link">
                <span> {{ $t("ui.breadcrump.all_projects") }} </span>
              </router-link>
            </span>
          </div>
          <!-- End of special cases -->

          <!-- Secondary header title -->
          <div class="space-between">
            <div class="secondary-header--title">
              {{ title }}
            </div>
            <div class="secondary-header--right" >
              <add-button v-if="!compressed" />
            </div>
          </div>
        </div>

        <folded-navigation
          :items="headerTabs"
          ref="foldedNavigation"
        />
      </div>

    </div>
  </div>
</template>
<script>
import FoldedNavigation from '@/components/layouts/partials/FoldedNavigation.vue'
import DotNavigation from '@/components/helpers/Layout/DotNavigation.vue'
import AddButton from '@/components/layouts/partials/AddButton.vue'
import GetUrlQueries from '@/classes/GetUrlQueries'

export default {
  components: {
    FoldedNavigation,
    DotNavigation,
    AddButton,
  },
  data(){
    return{
      folded: false,
    }
  },
  computed: {
    compressed() {
      return this.$store.getters.getHeaderState.compressed
    },
    computedSecondaryHeaderClass() {
      let classes = ['second-nav container-fluid']
      if (this.compressed) {
        classes.push('compressed')
      }
      return classes
    },
    isPageContent(){
      return this.$route.name == "content_manager"
    },
    headerTabs() {
      return this.$store.getters.getSecondaryHeaderTabs
    },
    level(){
      return this.$store.state.page_level
    },
    type(){
      return this.$store.state.page_type
    },
    title(){
      let pageTitle = this.$store.state.page_title
      if (pageTitle.params) {
        return this.$t(pageTitle.label, pageTitle.params)
      } else {
        return this.$t(pageTitle.label)
      }
    },
    breadcrumbs() {
      return this.$store.getters.getBreadcrumbs || []
    },
    subtitle(){
      return this.$store.getters.getSubtitle
    },
  },
  methods: {
    overflowHandler(payload){
      this.folded = payload
    },
    projectLeads() {
      return this.$route.name === "project_leads"
    },
    projectLeadEdit() {
      return this.$route.name === "project_lead_edit"
    },
    onClick(){
      //  We want to reset the leads page when we come back to the speficic project list page
      if (this.$route.name === "projects"){
        this.$store.commit('RESET_CURRENT_PAGE_LEADS')
      }
    },
    getProjectName() {
      if (this.$store.getters.getSubtitle.name) {
        return this.$store.getters.getSubtitle.name
      }
    },
    getProjectPathWithQueries() {
      return `/${this.$t("routes.project")}/${this.$route.params.id}/${this.$t("routes.project_leads")}${GetUrlQueries.urlQueries(this.$route.query)}`
    }
  }
}
</script>
<style lang="scss">
@media(max-width: 575px) {
    .secondary-header--right {
    .btn {
      font-size: 14px !important;
    }
    .actions .action {
      margin-right: .5em !important;
      img {
        max-width: 12px !important;
      }
    }
  }
  .secondary-header--title {
    font-size: 24px !important;
    padding-bottom: 15px;
  }
}
</style>
<style lang="scss" scoped>
.space-between {
  display: flex;
  justify-content: space-between;
}
.secondary-header {
  background: $paper-lighter;
  color: $ink;
  // overflow: hidden;
  @include respond-to("small"){
    margin-top: 20px;
  }
}

.secondary-header .second-nav {
  display: flex;
  align-items: center;
  padding-top: 88px;
  border-bottom: 1px solid $paper;
  background-color: $paper-lighter;
  min-height: 180px;

  &.compressed {
    min-height: 0;
  }
}

.secondary-header--left {
  flex-grow: 1;
  flex-shrink: 1;
  // text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
}

.secondary-header--title {
  // overflow: hidden;
  // text-overflow: ellipsis;
  display: block;
  vertical-align: middle;
  font-size: 26px;
  line-height: 32px;
  color: $ink;
  font-weight: $font-medium;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 35px 0px 28px 0px;
}

.secondary-header--subtitle,
.secondary-header--breadcrumbs {
  display: inline-block;
  color: $ink-lighter;
  font-size: 14px;
  font-weight: $font-regular;
  min-height: 20px;
  position: absolute;

  a{
    color: inherit;
    text-decoration: none;
    display: inline-block;
    transition: all .15s ease-out;
    margin-left: 20px;

    &.disabled {
      pointer-events: none;
    }

    &:hover{
      color: $ink;
    }
  }
}

.back-icon {
  position: relative;
  margin-right: 10px;

  &::before{
    @extend .icon;
    content: '\e909';
    font-size: 16px;
    padding-right: .5em;
    padding-top: 1px;
    position: absolute;
    top: 0px;
    left: 0;
  }
}

.secondary-header--middle {
  flex-grow: 2;
  flex-shrink: 5;
  margin-left: 1em;
  margin-right: 1em;
  overflow: hidden;
  position: relative;
  .navigation{
    display: flex;
  }
  .navigation ul{
    display: flex;
    position: relative;
    overflow: hidden;
  }
  .navigation .navigation-item{
    text-transform: uppercase;
    margin-right: 1em;
    font-size: 1.3em;
    white-space: nowrap;
  }
}

.secondary-header--dot-menu{
  margin-right: 1em;
  .dot-navigation--content{
    left: auto;
    right: 0;
  }
}

.secondary-header--right {
  display: flex;
  align-items: center;
  flex-grow: 0;
  text-align: right;
  .unpublished-changes {
    margin-right: 15px
  }
  .btn{
    margin-right: 0;
    white-space: nowrap;
  }
}

@media(max-width: 575px) {
  .secondary-header--right{
    margin-bottom: 2em;
  }
  .secondary-header--left {
    width: 100%;
  }
  .secondary-header .second-nav {
    padding: 50px 10px 0;
    flex-direction: column;
  }
  .space-between {
    flex-direction: column;
  }
  .secondary-header--title {
    padding-bottom: 17px;
  }
}

</style>



// WEBPACK FOOTER //
// SecondaryHeader.vue?26bb5b44